<div class="roster">
	<div class="roster__header">
		<span class="md-text-sm-medium">Attendance</span>
		@if (!readonly()) {
			<span class="md-text-xs-regular roster__hint">Check who is present — unchecked members are recorded absent</span>
		}
	</div>

	@for (member of members(); track member.enrollmentMemberID) {
		<div class="roster__row">
			<div class="roster__identity">
				<lb-user-icon [userID]="member.userID"></lb-user-icon>
				<span class="md-text-sm-regular">{{ memberName(member.userID) }}</span>
			</div>

			@if (readonly()) {
				@if (wasRecordedPresent(member)) {
					<md-tag type="success">Present</md-tag>
				} @else {
					<md-tag type="warning">Absent</md-tag>
				}
			} @else {
				<input
					md-form-input
					type="checkbox"
					[checked]="isPresent(member.enrollmentMemberID)"
					[disabled]="disabled()"
					(change)="toggle(member.enrollmentMemberID, $any($event.target).checked)"
				/>
			}
		</div>
	}

	@if (!readonly() && members().length > 0) {
		<div class="roster__row roster__row--no-attendees">
			<span class="md-text-sm-regular roster__no-attendees-label">No attendees</span>
			<input
				md-form-input
				type="checkbox"
				[checked]="noAttendees()"
				[disabled]="disabled() || presentCount() > 0"
				(change)="toggleNoAttendees($any($event.target).checked)"
			/>
		</div>
	}

	@if (members().length === 0) {
		<span class="md-text-sm-regular roster__empty">No members are on this lesson's roster.</span>
	}
</div>
